<div class="profile-messaging-container">
  <!-- Messages button -->
  <section class="messages-button-section" (click)="onToggleSidePanelRight()">
    <mat-icon
      class="messages-button-icon"
      [matBadge]="unreadNotificationsCount"
      matBadgePosition="after below"
      [matBadgeHidden]="unreadNotificationsCount == 0"
      aria-label="Messages icon"
      svgIcon="messaging"
      matTooltip="Messages"
      >
    </mat-icon>
  </section>

  <!-- Profile -->
  @if (this.viewAsStudent) {
    <section class="profile-options-section">
      <profile-image
        [profileUrl]="userProfile?.profileUrl"
        [radiusType]="radiusType"
        altText="Profile Image"
        matTooltip="Profile"
        role="presentation"
      ></profile-image>
    </section>
  }
  @if (!this.viewAsStudent) {
    <section
      class="profile-options-section"
      [matMenuTriggerFor]="profileOptionsMenu"
      >
      <profile-image
        [profileUrl]="userProfile?.profileUrl"
        [radiusType]="radiusType"
        altText="Profile Image"
        matTooltip="Profile"
        role="presentation"
      ></profile-image>
      <mat-icon class="profile-options-arrow">keyboard_arrow_down</mat-icon>
      <mat-menu #profileOptionsMenu="matMenu">
        <div fxLayout="column" id="profile-side-panel">
          <section
            class="header"
            fxLayout="row"
            fxLayoutAlign="center center"
            >
            <div fxLayout="column" class="user-info">
              <span class="user-name">{{ profileName }}</span>
            </div>
          </section>
          @if (timezoneMismatch) {
            <section
              class="timezone-container"
              fxFlex="100"
              fxLayout="row wrap"
              fxLayoutAlign="center center"
              >
              <div
                class="timezone-warning"
                fxFlex="100"
                fxLayoutAlign="center center"
                >
                <mat-icon class="warning-icon">warning</mat-icon>
                Dates/Times will display in your school's timezone.
              </div>
              <div
                fxFlex="100"
                fxLayoutAlign="center center"
                fxLayout="column"
                >
                <p class="timezone-label">
                  Local Timezone:
                  <span class="timezone-value">{{
                    localTimezoneDisplay
                  }}</span>
                </p>
                <p class="timezone-label">
                  School Timezone:
                  <span class="timezone-value">{{
                    schoolTimezone
                  }}</span>
                </p>
              </div>
            </section>
          }
          <mat-divider></mat-divider>
          <button
            class="profile-options-button standard-button button-small button-background-teal"
            (click)="editProfile()"
            >
            Profile
          </button>
          @if (userProfile?.roleLevel === 5) {
            <a
              class="profile-options-button help-center-button standard-button button-small-with-icon button-background-teal"
              target="_blank"
              [href]="getHelpCenterUrl()"
              >
              <mat-icon class="help-center-icon">help</mat-icon>
              Help Center
            </a>
          }
          <!--<button
          class="profile-options-button standard-button button-small button-background-teal"
          (click)="logout(false)"
          >
          Back to CL Portal
        </button>-->
        <button
          class="profile-options-button standard-button button-small button-background-teal"
          (click)="logout(true)"
          >
          Sign Out
        </button>
        <div class="profile-options-version">
          <div>
            Client {{ frontendBuildNumber }} Api
            {{ apiBuildNumber }}
          </div>
        </div>
      </div>
    </mat-menu>
  </section>
}
</div>
